import { Controller, Post, Body, Req, All } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { DesignationActionDTO } from './dto/designation-action.dto';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { AllDesignationActionResponseModel, DesignationActionResponseModel } from '@gtpl/shared-models/hrms';
import { DesignationActionRequest } from './dto/designation-action.request';
import { DesignationActionService } from './designation-action.service';

@ApiTags('designation-action')
@Controller('designation-action')
export class DesignationActionController {
    constructor(
        private service: DesignationActionService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}

    @Post('/createDesignationAction')
    async createLoanCategory(@Body() DTO: DesignationActionDTO, isUpdate: boolean = false): Promise<DesignationActionResponseModel>{
        try{
            return await this.service.createDesignationAction(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(DesignationActionResponseModel, error);
        }
    }

    @Post('/updateDesignationAction')
    async updateDesignationAction(@Body() DTO: DesignationActionDTO, isUpdate: boolean = false): Promise<DesignationActionResponseModel>{
        try{
            return await this.service.createDesignationAction(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(DesignationActionResponseModel, error);
        }
    }

    @Post('/getAllDesignationActions')
    async getAllDesignationAction(): Promise<AllDesignationActionResponseModel>{
        try{
            return await this.service.getAllDesignationActions();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllDesignationActionResponseModel, error);
        }
    }

    @Post('/getAllActiveDesignationAction')
    async getAllActiveDesignationAction(): Promise<AllDesignationActionResponseModel>{
        try{
            return await this.service.getAllActiveDesignationActions();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllDesignationActionResponseModel, error);
        }
    }

    @Post('/activateOrDeactivateDesignation')
    async activateOrDeactivateDesignation(@Body() catReq: DesignationActionRequest): Promise<DesignationActionResponseModel>{
        try{
            return await this.service.activateOrDeactivateDesignation(catReq);
        }catch(error){
            return this.applicationExceptionHandler.returnException(DesignationActionResponseModel, error);
        }
    }
}


